import { computed } from 'vue';
import { useAuthStore } from '~/auth/stores/auth.store.js';
import { useCommonStore } from '~/common/stores/common.store.js';
import { PLANS_ROUTES_CONFIG } from '~/plans/constants.js';

const MODULE_LANDING_ROUTES = {
  tasks: { name: 'tasks' },
  terra: { name: 'maps-list', params: { type: 'maps-list' } },
  therm: { name: 'maps-list', params: { type: 'maps-list' } },
  forms: { name: 'forms' },
  files: { name: 'dms' },
  photos: { name: 'photos' },
  transmittals: { name: 'files-transmittals' },
  pm: { name: 'project-management' },
  sm: { name: 'system-model' },
  plans: { name: PLANS_ROUTES_CONFIG.PLANS.name },
  inventory: { name: 'inventory' },
  bi: { name: 'bi-asset-dashboard' },
};

export function getAssetLandingRoute(asset) {
  const auth_store = useAuthStore();
  const asset_id = asset?.uid;
  const fallback = { name: 'asset-dashboard', params: { asset_id } };

  if (!asset_id)
    return fallback;

  const org_landing_page = auth_store.current_organization?.properties?.landing_page ?? null;
  const landing_page = asset?.properties?.landing_page ?? org_landing_page;

  if (!landing_page)
    return fallback;

  const asset_disabled_apps = asset?.disabled_apps || [];
  const org_disabled_apps = auth_store.current_organization?.disabled_apps || [];
  if (asset_disabled_apps.includes(landing_page) || org_disabled_apps.includes(landing_page))
    return fallback;

  const route_config = MODULE_LANDING_ROUTES[landing_page];
  if (!route_config)
    return fallback;

  return {
    ...route_config,
    params: { ...(route_config.params || {}), asset_id },
  };
}

export function useAssets() {
  const common_store = useCommonStore();
  const metadata_fields_columns = computed(() => {
    return common_store?.assets_custom_fields.map((field) => {
      return {
        header: field.name,
        accessorKey: field.uid,
        id: field.uid,
        cell: info => info.getValue(),
      };
    });
  });

  const all_columns = computed(() => {
    return [
      {
        header: 'Asset Name',
        accessorKey: 'uid',
        id: 'name',
        cell: info => info.getValue(),
        columns: [],
      },
      ...metadata_fields_columns.value,
    ];
  });

  return {
    all_columns,
  };
}
